module.exports = __webpack_public_path__ + "static/media/IIIe.c692803a.jpg";